import { defineStore } from "pinia";
import type { Subscription } from "server/types";
import type { UserPlan } from "types/shim";

export const usePlanStore = defineStore("plan", () => {
  const plan = ref<UserPlan>({} as UserPlan);
  async function fetchPlan() {
    const { isLoggedIn } = useUserStore();
    if (!isLoggedIn) return;
    let tryCount = 0;
    while (tryCount < 3) {
      try {
        const data = await get<{ plan: UserPlan }>("user/plan");
        plan.value = { ...(data.plan || {}) };
        break;
      } catch (e) {
        if (tryCount === 2) {
          message.error("Failed to fetch plan");
          plan.value = { failed: true } as UserPlan;
        } else {
          tryCount++;
        }
      }
    }
  }

  function setPlan(data: UserPlan = {} as UserPlan) {
    plan.value = data;
  }

  // 获取用户当前订阅
  async function fetchSubscription() {
    try {
      const { isLoggedIn } = useUserStore();
      if (!isLoggedIn) return null;
      if (!plan.value.active_subscription_id) return null;
      const data = await post<{ data: Subscription }>("subscriptions/current", {
        subscription_id: plan.value.active_subscription_id,
      });
      return data.data;
    } catch (e) {
      console.error("Failed to fetch subscription:", e);
      return null;
    }
  }

  // 取消订阅
  async function cancelSubscription(
    subscriptionId: string,
    reason?: string,
    enableAutoRenew?: boolean
  ) {
    try {
      const response = await post("subscriptions/cancel", {
        subscription_id: subscriptionId,
        reason,
        enableAutoRenew,
      });
      return response;
    } catch (e) {
      console.error("Failed to cancel subscription:", e);
      return { success: false, error: e };
    }
  }

  return {
    plan,
    fetchPlan,
    setPlan,
    fetchSubscription,
    cancelSubscription,
  };
});
